import React from 'react';
import { useStyles } from './styles';
const Navigation = ({ children, links }) => {
    const ownClasses = useStyles();
    return (React.createElement("div", { className: ownClasses.root },
        React.createElement("div", { className: ownClasses.items }, children),
        links && React.createElement("div", { className: ownClasses.links }, links)));
};
export default Navigation;
